import { useEffect, useState } from 'react';
import { errorToast } from '../utils/helper';
import { VisitService } from '../service/visitService';
import { Location, VisitActivity } from '@inplay/models';
import moment from 'moment';

export const useVisitActivity = (
  playerId: string,
  venueBranchIds: string[],
  startTime?: string,
  endTime?: string,
  location?: Location | undefined,
): {
  visitActivities: VisitActivity[];
  visitLoading: boolean;
} => {
  const [visitLoading, setVisitLoading] = useState<boolean>(true);
  const [visitActivities, setVisitActivities] = useState<VisitActivity[]>([]);

  useEffect(() => {
    if (venueBranchIds.length === 0) return;

    let start: number = startTime
      ? parseInt(startTime)
      : moment().startOf('day').unix();
    let end: number = endTime
      ? parseInt(endTime)
      : moment().endOf('day').unix();

    const fetchVisitActivites = async (): Promise<void> => {
      try {
        setVisitLoading(true);
        console.log(`[Fetching visits][ENTRY]`);
        const visitService: VisitService = new VisitService();
        const visitActivities: VisitActivity[] = await visitService.getVisits(
          start,
          end,
          playerId,
          venueBranchIds,
          location,
        );
        console.log(`[VisitActivity][fetchVisitActivities][SUCCESS]`, {
          visitActivities,
        });
        setVisitActivities(visitActivities);
      } catch (error: unknown) {
        errorToast(error);
      } finally {
        setVisitLoading(false);
      }
    };

    fetchVisitActivites();
  }, [startTime, endTime, playerId, venueBranchIds, location]);

  return { visitActivities, visitLoading };
};
